'use strict';
import Logger from '../../global/Logger';
import TrackingProvider from '../enums/TrackingProvider';
import SxQueryUtils from '../../sxQuery/SxQueryUtils';
var setPageGtm = function (currentUrl) {
    // @ts-ignore
    if (window.dataLayer) {
        // @ts-ignore
        window.dataLayer.push({
            event: 'VirtualPageview',
            category: 'search',
            virtualPageURL: currentUrl,
            virtualPageTitle: document.title
        });
    }
};
var Reporter = /** @class */ (function () {
    function Reporter(config) {
        this.actionStartTime = 0;
        this.config = config;
    }
    Reporter.prototype.setPage = function (currentUrl) {
        var providers = this.config.tracking.providers;
        // now inform tracking systems
        if (providers.indexOf(TrackingProvider.GA) > -1) {
            this.setPageGa(currentUrl);
        }
        if (providers.indexOf(TrackingProvider.GTM) > -1) {
            setPageGtm(currentUrl);
        }
    };
    Reporter.prototype.getGa = function () {
        if (this.config.tracking.gaAlias !== undefined) {
            // @ts-ignore
            return window[this.config.tracking.gaAlias];
        }
        // @ts-ignore
        return window.ga;
    };
    // Google Analytics
    Reporter.prototype.setPageGa = function (currentUrl) {
        var gaTracker = this.getGa();
        if (gaTracker) {
            gaTracker('set', 'page', currentUrl);
        }
    };
    Reporter.prototype.shouldTrack = function (context) {
        if (this.shouldTrackCache === undefined) {
            this.shouldTrackCache = this.config.tracking.logQueries && context.readCookie('ss360-tracking') !== '0';
        }
        return this.shouldTrackCache;
    };
    Reporter.prototype.initActionStartTime = function () {
        if (this.actionStartTime > 0) {
            return;
        }
        this.actionStartTime = new Date().getTime();
    };
    Reporter.prototype.getTimeToAction = function () {
        var tta = new Date().getTime() - this.actionStartTime;
        this.actionStartTime = 0; // reset so it gets reinitialized on the next event
        return tta;
    };
    Reporter.prototype.logQuery = function (query, action, context) {
        if (query === undefined || this.actionStartTime === 0 || query.trim().length < 3 || !this.shouldTrack(context)) {
            return;
        }
        var siteId = this.config.siteId;
        var tta = this.getTimeToAction();
        // avoid consecutive events, and tab is keydown + blur
        if (tta < 50) {
            return;
        }
        SxQueryUtils.post('https://global.sitesearch360.com/sites/queries/log', {
            query: query,
            site: siteId,
            timeToAction: tta,
            action: action
        });
    };
    Reporter.prototype.reportSerp = function (query, context) {
        if (!this.shouldTrack(context)) {
            return;
        }
        var shouldReport = true;
        var trackingConfig = this.config.tracking;
        var searchCallback = trackingConfig.searchCallback;
        if (searchCallback !== undefined && typeof searchCallback === 'function') {
            try {
                shouldReport = searchCallback.call(this, query) !== false;
            }
            catch (err) {
                Logger.warn(err);
            }
        }
        if (!shouldReport) {
            return;
        }
        // build URL
        var queryParamName = this.config.results.searchQueryParamName;
        var urlBase = window.location.href.split(window.location.origin)[1] || '';
        if (urlBase === '/') {
            urlBase = '';
        }
        if (queryParamName === undefined || queryParamName === '') {
            queryParamName = 'ss360Query';
        }
        try {
            urlBase = urlBase.replace(new RegExp(queryParamName + "=[^&]+", 'g'), '').replace(/\?&/g, '?').replace(/&&/g, '&');
        }
        catch (ex) {
            // ccl
        }
        if (urlBase.indexOf('?') === urlBase.length - 1) {
            urlBase = urlBase.substring(0, urlBase.length - 1);
        }
        var queryChar = urlBase.indexOf('?') === -1 ? '?' : '&';
        var currentUrl = trackingConfig.ignoreQueryParam ? urlBase : "" + urlBase + queryChar + queryParamName + "=" + encodeURI(query).toLowerCase();
        this.setPage(currentUrl);
        var gaTracker = this.getGa();
        if (trackingConfig.providers.indexOf(TrackingProvider.GA) > -1 && (!!gaTracker)) {
            gaTracker('send', 'pageview');
            gaTracker(function (tracker) {
                if (tracker === undefined) {
                    gaTracker.getAll().forEach(function (tr) {
                        tr.set('page', currentUrl);
                        tr.send('pageview');
                    });
                }
            });
        }
    };
    return Reporter;
}());
export default Reporter;
